import { client } from '../../../../../common-utils/libraries/axios/axios';
import { SIM_CARDS } from '../apiUrls';
import simCardFields from '../../fields/simCardFields';

/**
 * @param root0
 * @param root0.simProviders
 * @returns Mapped data object
 */
function mapResponseData({ simProviders }) {
    const data = {};

    const mappedItems = simProviders.map((item) => {
        return {
            [simCardFields.SIM_PROVIDERS.PROVIDER_NAME.key]: item[simCardFields.SIM_PROVIDERS.PROVIDER_NAME.key],
            [simCardFields.SIM_PROVIDERS.QUANTITIES.key]: item[simCardFields.SIM_PROVIDERS.QUANTITIES.key]
        };
    });

    data.simProviders = mappedItems;
    return data;
}

const queryGetSimProviders = (enabled) => {
    return {
        queryKey: [SIM_CARDS.PROVIDERS.queryKey],
        queryFn: async () => {
            const response = await client.get(SIM_CARDS.PROVIDERS.url);
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetSimProviders;